// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__agG-1","paramInput":"JobSimulator_paramInput__3p6_X","input":"JobSimulator_input__2KArm"};